<template>
  <div class="main">
    <DetailsMenu :course="course" title="Course Details" current="Details" />

    <div class="row no-gutters py-4">
      <div v-if="!!course.is_expired" class="col-12 px-4 mb-4">
        <div class="alert alert-danger text-center">
          <p class="mb-0">
            Your purchase period for this course has expired. Your access to the
            online course is no longer available. Please return to the&nbsp;
            <a
              class="text-dark text-underline"
              :href="route('catalog.course', { course: course.id })"
              ><u>Course Catalog</u></a
            >
            &nbsp;to rent this course again.
          </p>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xxl-5 mb-5 mb-xxl-0">
        <div class="px-3 pl-xxl-4">
          <DetailsPane
            :course="course"
            section="training"
            :hide-close="true"
            :auto-height="true"
            :hide-description="true"
            :hide-launch-button="false"
          />
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xxl-7 px-4">
        <template v-if="!!course.can_launch && course.lessons.length > 0">
          <h3 class="text-primary text-uppercase font-weight-bold mb-3">
            Lessons in this Series
          </h3>
          <div class="listable mb-4">
            <div
              v-for="(lesson, i) in course.lessons"
              :key="i"
              class="listable-data"
            >
              <div class="card">
                <div class="card-body">
                  <div
                    class="icon-check"
                    :class="{ checked: lessonsViewed.includes(lesson.id) }"
                  />
                  <div class="card-title text-dark">{{ lesson.name }}</div>
                  <div class="card-text">
                    <a
                      class="btn-sm btn-secondary"
                      href="#"
                      @click.prevent="playLesson(lesson)"
                      >Play Lesson</a
                    >
                  </div>
                </div>
              </div>
              <div class="td col-checkbox">
                <div
                  class="icon-check"
                  :class="{ checked: lessonsViewed.includes(lesson.id) }"
                />
              </div>
              <div class="td">{{ lesson.name }}</div>
              <div class="td col-button text-right">
                <a
                  class="btn-sm btn-secondary"
                  href="#"
                  @click.prevent="playLesson(lesson)"
                  >Play Lesson</a
                >
              </div>
            </div>
          </div>
        </template>
        <template v-if="course.description.length > 0">
          <h3 class="text-primary text-uppercase font-weight-bold mb-3">
            Course Description
          </h3>
          <div v-html="course.description"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsMenu from "./partials/DetailsMenu";
import DetailsPane from "components/partials/Courses/DetailsPane";
import VideoModal from "components/elements/VideoModal";

export default {
  components: { DetailsMenu, DetailsPane, VideoModal },
  props: {
    course: { type: Object, required: true },
  },
  data() {
    return {
      lessonsViewed: [],
    };
  },
  methods: {
    playLesson(lesson) {
      this.$modal(VideoModal, { videoUrl: lesson.asset.url })
        .then(() => {
          this.trackLessonView(lesson);
        })
        .catch(() => {
          this.trackLessonView(lesson);
        });
    },
    trackLessonView(lesson) {
      if (!this.lessonsViewed.includes(lesson.id)) {
        var route = this.route("training.courses.lesson", {
          lesson: lesson.id,
        });
        this.axios.get(route).then(() => {
          this.lessonsViewed.push(lesson.id);
        });
      }
    },
  },
  mounted() {
    if (this.course.lessons.length > 0) {
      this.course.lessons.forEach((lesson) => {
        if (!!lesson.viewed) {
          this.lessonsViewed.push(lesson.id);
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "sass/variables";

.listable {
  .icon-check {
    background-color: $gray-300;
    height: 1.5rem;
    width: 1.5rem;
    position: absolute;
    font-size: 0.5rem;
    &:before {
      color: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: none;
    }
    &.checked {
      background-color: $primary;
      &:before {
        display: block;
      }
    }
  }
  .card .icon-check {
    right: 0.5rem;
    top: 0.5rem;
  }
  .col-checkbox {
    width: 3rem;
  }
  .col-button {
    width: 6.5rem;
  }
}
</style>